const json = `
<p>版本生效日期：2026年6月22日</p>
<p>版本更新日期：2026年6月22日</p>
<p>欢迎您使用 DV Link。DV Link 由广州钱柜物联科技有限公司（以下简称“我们”）提供。请您在使用本应用前仔细阅读并充分理解本《DV Link 用户协议》（以下简称“本协议”），尤其是与服务范围、用户责任、风险提示、责任限制、协议变更、争议解决相关的条款。</p>
<p>如您不同意本协议的全部或部分内容，请停止使用本应用。您下载、安装、打开、使用本应用，或点击同意本协议，即表示您已阅读、理解并同意接受本协议约束。</p>
<p class="subTitle">一、协议范围</p>
<p>1. 本协议适用于 DV Link iOS / iPadOS 应用及其相关功能。</p>
<p>2. 本协议与《DV Link 隐私政策》共同构成您使用本应用的基本规则。涉及个人信息处理、系统权限、数据保存和用户权利的内容，请同时阅读《DV Link 隐私政策》。</p>
<p>3. 如本应用后续新增付费服务、账号服务、云端同步、在线客服、第三方 SDK 或其他新功能，我们可能会发布补充协议、专项规则或更新后的协议。补充协议、专项规则经依法公示或向您提示后，与本协议具有同等效力。</p>
<p class="subTitle">二、服务内容</p>
<p>1. DV Link 是一款用于 USB 直录设备录像导入与本地播放的工具类应用。</p>
<p>2. 本应用当前核心流程为：您连接 USB 直录设备后，通过 iOS 系统文件选择器选择设备文件夹或录像文件夹；本应用在您授权的范围内扫描可识别的录像文件；您可以将选定录像下载到 iPhone 或 iPad 本地，并进行本地播放、管理、分享或导出。</p>
<p>3. 本应用当前版本不提供账号注册、登录功能，不提供云端同步、云端备份、远程设备控制、固件升级、实时预览或设备私有协议通信功能。</p>
<p>4. 本应用不自动监听 USB 插入事件，不绕过 iOS 系统文件选择器静默读取外部存储根目录，不承诺插入设备后自动连接或自动识别全部 USB 设备。</p>
<p>5. 本应用是否能够识别或读取外接设备，可能受到 iOS / iPadOS 系统版本、设备型号、转接头、供电状态、USB 设备文件系统、文件目录结构、文件格式、用户授权状态等因素影响。</p>
<p class="subTitle">三、使用条件</p>
<p>1. 您应当具备与使用本应用相适应的民事行为能力。若您是不满十四周岁的儿童或其他限制民事行为能力人，请在父母或其他监护人的同意和指导下使用本应用。</p>
<p>2. 您使用本应用处理的录像、图片、文件或其他内容，应当来源合法，并且您应当对相关内容享有合法的查看、复制、播放、分享、导出或处理权限。</p>
<p>3. 您不得利用本应用侵犯他人隐私权、肖像权、名誉权、知识产权、商业秘密或其他合法权益，不得利用本应用从事违法犯罪活动。</p>
<p>4. 您应当自行妥善保管自己的 iPhone、iPad、系统账号、USB 设备、转接头、本地录像文件和其他资料。</p>
<p class="subTitle">四、设备文件夹授权与本地录像管理</p>
<p>1. 本应用通过 iOS 系统文件选择器获取您主动选择的文件夹访问授权。只有在您主动选择并授权后，本应用才会读取授权范围内的文件。</p>
<p>2. 您应当根据应用内说明，在系统文件选择器中选择正确的 USB 设备根目录、录像目录或其他可识别目录。若您选择错误目录，本应用可能无法扫描到录像或无法正常展示设备内容。</p>
<p>3. 本应用可能在设备本地保存文件夹授权记录、录像索引、下载状态、缩略图、本地保存路径等必要信息，以便恢复授权状态、展示录像列表、避免重复下载和支持本地播放。</p>
<p>4. 您下载到手机或平板本地的录像由您自行管理。删除本地录像仅会删除本应用本地存储空间中的副本，不会删除、移动、重命名或修改 USB 设备中的原始文件。</p>
<p>5. 您在删除本地录像、清理缓存、清除授权、卸载应用、系统恢复、设备更换或手动管理文件前，应根据需要自行备份重要内容。</p>
<p class="subTitle">五、用户行为规范</p>
<p>您在使用本应用时，不得实施以下行为：</p>
<p>1. 上传、制作、复制、存储、播放、分享、传播任何违反法律法规、公序良俗或侵犯他人合法权益的内容。</p>
<p>2. 未经他人同意处理包含他人隐私、肖像、声音、通信内容、个人信息或其他敏感内容的录像或文件。</p>
<p>3. 利用本应用规避系统权限、安全机制、访问控制或第三方平台规则。</p>
<p>4. 对本应用进行反向工程、反向编译、反汇编、破解、篡改、绕过授权、植入恶意代码或进行其他破坏应用正常运行的行为，但法律法规明确允许的除外。</p>
<p>5. 利用本应用或相关服务进行攻击、扫描、干扰、破坏、过载、爬取、批量测试或其他影响我们、用户、第三方系统安全和稳定的行为。</p>
<p>6. 冒用他人身份、虚构事实、恶意投诉、恶意反馈，或以其他方式损害我们、其他用户或第三方合法权益。</p>
<p>如您违反本协议或法律法规，我们有权根据违法违规程度依法采取提醒、限制相关功能、停止提供服务、保存必要记录、向主管机关报告等措施。因您的行为造成我们、其他用户或第三方损失的，您应依法承担相应责任。</p>
<p class="subTitle">六、内容权利与授权</p>
<p>1. 您通过本应用读取、下载、播放、分享或导出的录像、图片、文件等内容，其权利归属不因您使用本应用而发生转移。</p>
<p>2. 对于您依法享有权利的内容，您仍保留相应权利；您应确保相关内容的使用不侵犯任何第三方合法权益。</p>
<p>3. 除为实现本应用本地播放、下载、缩略图生成、分享、导出、故障排查等功能所必需的处理外，我们不会主动取得您录像内容的所有权或其他不必要权利。</p>
<p>4. 如您通过邮件或其他方式向我们提交问题反馈、截图、日志、录像片段或其他材料，您同意我们在处理反馈、定位问题、改进产品和履行法定义务所必需的范围内使用相关材料。</p>
<p class="subTitle">七、知识产权</p>
<p>1. 本应用及其相关软件、界面设计、交互设计、图标、文字、商标、标识、技术文档、代码、算法、数据结构等内容，除依法属于第三方或用户自行提供的内容外，其知识产权及相关权益归我们或合法权利人所有。</p>
<p>2. 未经我们或相关权利人事先书面许可，您不得复制、修改、改编、翻译、发行、出租、展示、传播、转让、许可、出售本应用或其组成部分，不得移除、遮挡或修改本应用中的权利声明、商标或标识。</p>
<p>3. 本协议未明示授权给您的权利，均由我们或相关权利人保留。</p>
<p class="subTitle">八、隐私与个人信息保护</p>
<p>1. 我们会按照《DV Link 隐私政策》处理您的个人信息和相关数据。</p>
<p>2. 本应用当前版本不提供账号注册、登录功能，暂不接入第三方 SDK，不进行广告投放、跨应用追踪或第三方广告归因。</p>
<p>3. 为保障应用稳定运行、排查崩溃问题、优化扫描、下载和播放体验，本应用可能会在依法取得必要授权或同意后，通过我们自有的日志和分析能力收集崩溃日志、性能数据、设备型号、系统版本、应用版本等运行诊断信息。</p>
<p>4. 您可以按照《DV Link 隐私政策》中的说明管理相册、通知、文件夹访问等系统权限，并行使查询、更正、删除、撤回授权等个人信息相关权利。</p>
<p class="subTitle">九、第三方服务与系统能力</p>
<p>1. 本应用可能调用 iOS / iPadOS 系统文件选择器、系统分享、相册、通知、本地存储、媒体播放等系统能力。相关系统能力由 Apple 或操作系统提供，其可用性、展示方式、权限弹窗和行为可能因系统版本、设备型号或 Apple 政策变化而不同。</p>
<p>2. 当您主动使用系统分享、导出功能，将录像交由其他应用、联系人、平台或服务处理时，该第三方如何处理相关内容，适用该第三方自身的协议、隐私政策和服务规则。</p>
<p>3. 我们建议您在分享、导出或发送包含个人信息、他人影像、声音、车牌、住址、商业秘密或其他敏感信息的录像前，审慎确认接收方和分享范围。</p>
<p class="subTitle">十、服务变更、中断与终止</p>
<p>1. 我们可能根据产品规划、技术升级、系统适配、法律法规、平台规则或安全需要，对本应用功能、界面、服务规则进行调整。</p>
<p>2. 因系统维护、版本更新、网络故障、设备故障、第三方系统变更、不可抗力、法律法规或主管机关要求等原因，本应用部分功能可能发生中断、延迟、异常或无法使用。</p>
<p>3. 如我们停止提供本应用或其中部分功能，我们将依法通过应用内提示、更新说明、公告或其他适当方式进行通知；法律法规另有规定的，从其规定。</p>
<p>4. 您可以随时停止使用或卸载本应用。卸载本应用通常会删除本应用沙盒内保存的数据，但您已导出、分享、保存到相册或存储于其他位置的文件可能不会随应用卸载而删除。</p>
<p class="subTitle">十一、风险提示与责任限制</p>
<p>1. 请您理解，本应用是基于 iOS / iPadOS 系统文件访问机制提供的工具类应用。我们会尽合理努力保障本应用按说明提供功能，但不保证所有 USB 设备、转接头、文件系统、目录结构、录像格式或系统版本均可兼容。</p>
<p>2. 因您选择错误目录、拔出设备、设备断电、存储空间不足、USB 设备故障、转接头故障、系统权限变化、文件损坏、第三方应用处理、您主动删除或分享文件等非我们原因导致的文件不可访问、下载失败、播放失败、数据丢失、内容泄露或其他损失，由您自行承担相应后果。</p>
<p>3. 对于本应用明确提示为“删除本地录像”“清除授权”“清理缓存”等操作，请您在操作前仔细确认。相关操作完成后，可能无法在本应用内恢复。</p>
<p>4. 本协议中的责任限制不适用于因我们故意或重大过失造成您人身损害，或因我们故意或重大过失造成您财产损失的情形；法律法规另有强制规定的，从其规定。</p>
<p>5. 在法律法规允许的范围内，我们对您因使用或无法使用本应用所产生的间接损失、可得利益损失、商誉损失、数据恢复成本、第三方索赔等不承担超出法律规定范围的责任，但因我们依法应承担责任的情形除外。</p>
<p class="subTitle">十二、费用与付款</p>
<p>1. 本应用当前版本未提供应用内付费订阅、会员服务或云端增值服务。</p>
<p>2. 您下载、安装或使用本应用过程中，可能由网络运营商、设备厂商、Apple 或其他第三方收取网络流量、设备、系统、存储或其他费用，该等费用由相关第三方按其规则收取。</p>
<p>3. 如后续本应用提供付费功能、订阅、会员或其他增值服务，我们会在购买前向您明示服务内容、价格、计费周期、自动续费、取消方式和退款规则，并遵守 Apple App Store 及相关法律法规要求。</p>
<p class="subTitle">十三、未成年人保护</p>
<p>1. 本应用并非专门面向不满十四周岁的儿童设计。</p>
<p>2. 未成年人使用本应用前，应取得父母或其他监护人的同意，并在监护人的指导下使用。</p>
<p>3. 监护人应指导未成年人合法、审慎使用录像、分享、导出、相册、通知等功能，避免处理或传播侵犯他人权益、含有敏感信息或不适宜未成年人接触的内容。</p>
<p class="subTitle">十四、协议变更</p>
<p>1. 我们可能根据产品功能、法律法规、平台规则或运营需要更新本协议。</p>
<p>2. 本协议更新后，我们会通过应用内提示、更新说明、公告或其他适当方式向您提示，并标明更新日期。</p>
<p>3. 如更新内容涉及您重大权益，我们会以适当方式进行显著提示；依法需要取得您同意的，我们会在取得您的同意后再提供相应服务。</p>
<p>4. 若您不同意更新后的协议，您可以停止使用本应用；您在协议更新后继续使用本应用的，视为您已接受更新后的协议，但法律法规另有规定的除外。</p>
<p class="subTitle">十五、法律适用与争议解决</p>
<p>1. 本协议的订立、生效、履行、解释和争议解决，适用中华人民共和国大陆地区法律；法律冲突规范不适用。</p>
<p>2. 因本协议或您使用本应用产生的争议，双方应先友好协商解决。</p>
<p>3. 协商不成的，任何一方均可依法向有管辖权的人民法院提起诉讼。</p>
<p class="subTitle">十六、联系我们</p>
<p>服务提供者：广州钱柜物联科技有限公司</p>
<p>联系地址：广州市南沙区南沙街道华汇国际广场916</p>
<p>联系电话：020 34974033</p>
<p>支持邮箱：naxclow@163.com</p>
<p>如您对本协议或本应用服务有任何疑问、意见、投诉或建议，可以通过以上联系方式联系我们。我们会在收到您的请求并核验必要信息后，依法在合理期限内处理和回复。</p>
`

export default json
